export default __webpack_public_path__ + "static/media/RobotoCondensed-BoldItalic.10efc48e.ttf";